<template>
  <CustomAlert :title="title" :type="type" :borderWidth="2">
    <p>{{ message }}</p>
    <routerLink
      type="button"
      class="btn btn-primary mt-3 fw-bold"
      :to="{ name: 'Achievements' }"
    >
      {{ buttonLabel }}
      <i
        v-if="buttonIcon"
        class="bi bi-arrow-counterclockwise ms-1"
        :class="buttonIcon"
      ></i>
    </routerLink>
  </CustomAlert>
</template>

<script>
import CustomAlert from "@/components/ui/CustomAlert.vue";

export default {
  name: "DynamicAlert",
  components: {
    CustomAlert
  },
  props: {
    title: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    buttonLabel: {
      type: String,
      required: true
    },
    buttonIcon: {
      type: String,
      required: false,
      default: null
    }
  }
};
</script>
